<div class="create-bom-modal">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Add Bom</h5>
  </div>
  <div class="modal-body">
    <form *ngIf="formGroup" [formGroup]="formGroup">
      <div class="mb-3">
        <label class="m-r-5 m-b-1">Parent Name:</label>
        <app-lookup-input
          itemName="Bom"
          [group]="formGroup"
          [lookUpConfig]="parentLookupConfig"
          [control]="parentNameControl"
          controlName="parentName"
        ></app-lookup-input>

        <div
          *ngIf="
            parentNameControl.errors &&
            (parentNameControl.dirty || parentNameControl.touched)
          "
          class="small"
        >
          <label *ngIf="parentNameControl.hasError('required')">
            <b class="text-danger">Parent Name is required.</b>
          </label>
        </div>
      </div>

      <form
        *ngFor="let childFormGroup of childFormGroups; index as childIdx"
        [formGroup]="childFormGroup"
        class="d-flex justify-content-between align-items-center gap-2 mb-4"
      >
        <h3 class="align-self-end">{{ childIdx + 1 }}</h3>
        <div style="min-width: 275px" class="position-relative">
          <label class="m-r-5 m-b-1">Component Name:</label>
          <app-lookup-input
            itemName="Bom"
            [group]="childFormGroup"
            [lookUpConfig]="childLookupConfig"
            [control]="childFormGroup.get('childName')"
            [parentKey]="parentKeyControl?.value"
            [isDisabled]="!parentKeyControl?.value"
            controlName="childName"
          ></app-lookup-input>
          <div
            *ngIf="
              childFormGroup.get('childName').errors &&
              (childFormGroup.get('childName').dirty ||
                childFormGroup.get('childName').touched)
            "
            class="small position-absolute"
          >
            <label *ngIf="childFormGroup.get('childName').hasError('required')">
              <b class="text-danger">Component Name is required.</b>
            </label>
          </div>
        </div>

        <div style="max-width: 250px" class="position-relative">
          <label class="m-r-5 m-b-1">Kit Qty:</label>
          <input
            integerNumber
            class="form-control"
            type="number"
            formControlName="qty"
            [ngClass]="{
              'is-invalid':
                !childFormGroup.get('qty')?.valid &&
                (childFormGroup.get('qty')?.dirty ||
                  childFormGroup.get('qty')?.touched)
            }"
          />
          <div
            *ngIf="
              childFormGroup.get('qty').errors &&
              (childFormGroup.get('qty').dirty ||
                childFormGroup.get('qty').touched)
            "
            class="small position-absolute"
          >
            <label *ngIf="childFormGroup.get('qty').hasError('required')">
              <b class="text-danger">Kit Qty is required.</b>
            </label>
            <label *ngIf="childFormGroup.get('qty').hasError('min')">
              <b class="text-danger">Min is 1.</b>
            </label>
            <label *ngIf="childFormGroup.get('qty').hasError('max')">
              <b class="text-danger">Max is 99999.</b>
            </label>
          </div>
        </div>

        <div
          class="align-self-end"
          [class.btn-group]="childFormGroups?.length > 1"
          [class.d-flex]="childFormGroups?.length <= 1"
        >
          <button
            type="button"
            class="btn btn-secondary"
            [class.invisible]="childFormGroups?.length <= 1"
            (click)="removeChild(childIdx)"
          >
            <i class="fa fa-minus"></i>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            [class.invisible]="childFormGroups?.length > 10"
            (click)="addChild()"
          >
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </form>
    </form>

    <div *ngIf="isChildrenDuplicated" class="text-danger">
      <b>Duplicate kits are not allowed.</b>
    </div>
  </div>
  <div class="modal-footer p-10">
    <div>
      <button
        type="button"
        class="btn btn-link"
        (click)="activeModal.dismiss()"
      >
        Cancel
      </button>
    </div>
    <button
      type="button"
      class="btn btn-success"
      (click)="save()"
      [disabled]="formGroup?.invalid || isChildrenDuplicated || isLoading"
    >
      Save
    </button>
  </div>
</div>
